import { useCartCheckoutSession } from "./order-processing/useCartCheckoutSession";

export default function useClearCartCheckoutSession() {
  const { clearCartOrderTokenCookie } = useCartCheckoutSession();
  const { clearCartToken } = useCartSession();

  const orderStore = useOrderStore();
  const { clearCart } = useCartStore();

  const clearSession = () => {
    clearCartOrderTokenCookie();
    orderStore.$reset();
  };

  const clearOrderWithCart = () => {
    //reseting cart checkout session
    clearCartOrderTokenCookie();
    orderStore.$reset();

    //reseting cart
    clearCartToken();
    clearCart();
  };

  return {
    clearSession,
    clearOrderWithCart,
  };
}
